import PropTypes from 'prop-types'
import React from 'react'
import { formatPrice } from 'shared-constants'
import { flexbox, layout } from 'styled-system'
import Icon from 'components/Icon'
import { Flex } from 'components/Layout'
import { H5, Text } from 'components/Typography'
import { COLOR, SPACE, FONT_SIZE, FONT_WEIGHT } from 'Theme'

export const RevenueSummaryLegend = ({
  color,
  label,
  price,
  currency,
  ...styledProps
}) => (
  <Flex {...styledProps}>
    <Icon.Dot color={color} size={20} marginX={SPACE.PX_5} />
    <Flex flexDirection="column">
      <Text
        color={COLOR.GRAYSCALE_2}
        fontWeight={FONT_WEIGHT.MEDIUM}
        fontSize={{ MOBILE: FONT_SIZE.PX_14, TABLET: FONT_SIZE.PX_16 }}
        mb={SPACE.PX_5}
      >
        {label}
      </Text>
      <H5
        color={COLOR.BLACK}
        fontSize={{ MOBILE: FONT_SIZE.PX_16, TABLET: FONT_SIZE.PX_20 }}
        isEllipsis
      >
        {formatPrice({
          price,
          currency,
        })}
      </H5>
    </Flex>
  </Flex>
)

RevenueSummaryLegend.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  ...flexbox.propTypes,
  ...layout.propTypes,
}
